import React from 'react'
import './about.css'
import AboutUsImage from '../../images/aboutus.png';
const AboutComponent = () => {
    return (
        
        <div className='aboutPageCss'>
            <div className='aboutPageBanner'>
                <div className='aboutLeftWrapper' >
                    <img width={'80%'} src={AboutUsImage}></img>
                </div>
                <div className='aboutRightWrapper'>
                    
                    <div className='aboutUsHeading'>
                        About us
                        <div style={{marginTop:'10px',borderBottom:'2px solid var(--logo-color)'}}></div>
                    </div>
                    <div style={{marginTop:'20px',fontSize:'18px',lineHeight:'25px'}}>
                        We’re a Mobile Marketing team that focuses on helping Advertisers and Publishers to reach new heights in Mobile User Acquisition. We are on a mission to help Advertisers and Affiliates to achieve best ROIs in Mobile User Acquisition.
                        <br/>
                        <br/>
                        We are a full stack user acquisition platform which empowers both Advertisers and Publishers to exceed their high demanding targets through successful strategies and innovative tools.
                        <br/>
                        <br/>
                        Our dedicated account management team works closely with clients to understand their objectives in detail and help them to execute customized comprehensive marketing strategies.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutComponent